<template>
    <div class="grid grid-cols-2 px-5 py-5">
        <div>
            <p class="text-lg font-bold">Email settings</p>

            <div class="mt-4 grid w-full max-w-md items-center gap-1.5">
                <Label for="email">Email name</Label>
                <Input
                    v-model="workflowCopy.name"
                    id="email"
                    type="email"
                    placeholder="Email"
                />
            </div>

            <div class="mt-4 grid w-full max-w-md items-center gap-1.5">
                <Label for="email"
                    >When will be reminder send before booking
                </Label>
                <InputWithSelect v-model="test" />
            </div>
            <div class="mt-4 grid w-full max-w-md items-center gap-1.5">
                <Label for="email">From </Label>
                <Input
                    :model-value="'support@zaptime.app'"
                    type="email"
                    placeholder="Email"
                />
            </div>

            <div class="mt-4 grid w-full max-w-md items-center gap-1.5">
                <Label for="email">To </Label>
                <Select v-model:model-value="recieverId">
                    <SelectTrigger>
                        <SelectValue placeholder="Select a fruit" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                            <SelectItem
                                v-for="rec of recievers"
                                :value="rec.id"
                            >
                                {{ rec.label }}
                            </SelectItem>
                        </SelectGroup>
                    </SelectContent>
                </Select>
            </div>

            <div class="mt-4 grid w-full max-w-md items-center gap-1.5">
                <Label for="email">Email subject </Label>
                <Input
                    :model-value="'Reminder for upcoming booking'"
                    type="text"
                    placeholder="Email"
                />
            </div>
        </div>
        <div>
            <p class="text-lg font-bold">Email Preview</p>
            <div class="mt-4 rounded-md border border-iron-300 p-6">
                <img
                    width="40"
                    height="40"
                    src="https://storage.googleapis.com/topolio13546/plugin-assets/6320/13546/ZPT-images/ZAP-Logomark.png"
                    alt=""
                />

                <p class="mt-8 text-xl font-bold text-iron-900">
                    Reservation created
                </p>

                <p class="mt-4 text-iron-900">
                    Hello <span v-pre>{{ NAME }}</span
                    >,<br />
                    <br />
                    Thanks for scheduling an event for
                    <span v-pre>{{ EVENT_DATE }}</span>
                </p>

                <p class="mt-8 font-bold text-iron-700">Reservation details</p>

                <div class="mt-4">
                    <p>
                        Event: <span v-pre>{{ EVENT_TYPE_NAME }}</span>
                    </p>
                    <p>
                        Duration: <span v-pre>{{ BOOKING_DURATION }}</span>
                    </p>
                    <p>
                        Location: <span v-pre>{{ BOOKING_LOCATION }}</span>
                    </p>
                </div>

                <div class="mt-4">
                    <a class="block font-bold text-z-primary-700"
                        >Cancel this reservation</a
                    >
                    <a class="font-bold text-z-primary-700"
                        >Reschedule this reservation</a
                    >
                </div>
                <!-- <EmailContent v-model="emailContent" /> -->
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Workflow } from "../Workflow.vue";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ref } from "vue";
import { useFormattedSeconds } from "@/composables/useFormattedSeconds";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { InputWithSelect } from "@/components/ui/input-with-select";
const { convertSeconds } = useFormattedSeconds();

import { usePage } from "@inertiajs/vue3";
import EmailContent from "./EmailContent.vue";

const page = usePage();

const test = ref();

const recievers = [
    {
        id: "1",
        //@ts-expect-error
        label: `Your email: ${page.props.user.email}`,
    },
    {
        id: "2",
        label: "Bookers email obtained in the booking",
    },
    // {
    //     id: "3",
    //     label: "Custom emails",
    // },
];

const recieverId = ref(recievers[0].id);

const emailContent = ref("");

const props = defineProps<{
    workflow: Workflow;
}>();

console.log(props.workflow);

const workflowCopy = ref(props.workflow);
</script>
